import { UUID } from '../shared/UUID';
import { eOrderGroupCategory } from '../../ui-toolkit/enums/eOrderGroupCategory';

export interface MobilityProgramType {
  name: string;
  label: string;
}

export interface IMobilityTransactionTypeResponse {
  id: string;
  label: string;
}

export type MobilityTransactionTypeData = IMobilityTransactionTypeResponse;

export interface IMobilityGroup {
  id: UUID;
  externalId?: string;
  clientId?: UUID;
  programType?: MobilityProgramType | null;
  takeTitle?: boolean | null;
}

export interface IMobilityOrder {
  orderId: UUID;
  transactionType: MobilityTransactionTypeData;
  orderGroupCategory: eOrderGroupCategory;
  orderGroupId?: string;
  groupId: UUID;
}

export interface IMobilityGroupWithOrders extends IMobilityGroup {
  mobilityOrders: IMobilityOrder[];
}

export interface IEditMobilityGroupRequest {
  externalId?: string;
  programTypeId?: string | null;
  takeTitle?: boolean | null;
}

export interface IEditMobilityGroup {
  id: UUID;
  externalId?: string;
  programTypeId?: string | null;
  takeTitle?: boolean | null;
}

export interface IProgramTypeResponse {
  name: string;
  label: string;
}

export type IProgramTypeData = IProgramTypeResponse;

export const convertToEditMobilityGroupRequest = ({
  externalId,
  programTypeId,
  takeTitle,
}: IEditMobilityGroup): IEditMobilityGroupRequest => ({
  externalId,
  programTypeId,
  takeTitle,
});

export const convertToEditMobilityGroup = ({
  id,
  externalId,
  programType,
  takeTitle,
}: IMobilityGroupWithOrders): IEditMobilityGroup => ({
  id,
  externalId: externalId!,
  programTypeId: programType != null ? programType?.name : null,
  takeTitle,
});
